import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core'
import { ColumnInterface } from '@shared/interfaces/column.interface'
import {
	CdkDrag,
	CdkDragDrop,
	CdkDragHandle,
	CdkDragPreview,
	CdkDropList,
	moveItemInArray,
} from '@angular/cdk/drag-drop'
import { TranslatePipe } from '@ngx-translate/core'
import { TuiDataListComponent, TuiIcon } from '@taiga-ui/core'
import { TuiCheckbox } from '@taiga-ui/kit'

@Component({
	selector: 'app-dropdown-columns-actions',
	templateUrl: './dropdown-columns-actions.component.html',
	styleUrl: './dropdown-columns-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CdkDrag,
		CdkDragHandle,
		CdkDragPreview,
		CdkDropList,
		TranslatePipe,
		TuiDataListComponent,
		TuiIcon,
		TuiCheckbox,
	],
})
export class DropdownColumnsActionsComponent<T = string> {
	protected readonly string: typeof String = String

	public columns: InputSignal<ColumnInterface<T>[]> = input<ColumnInterface<T>[]>([])
	public translationPrefix: InputSignal<string> = input<string>('')
	public isDraggable: InputSignal<boolean> = input<boolean>(true)
	public showDragIcon: InputSignal<boolean> = input<boolean>(true)
	public columnsChange: OutputEmitterRef<ColumnInterface<T>[]> = output<ColumnInterface<T>[]>()

	protected checkVisibleColumn(column: T): boolean {
		return !!this.columns().find((col: ColumnInterface<T>): boolean => col.column === column)?.visible
	}

	protected toggleVisibleColumn(column: T): void {
		const updatedColumns: ColumnInterface<T>[] = this.columns().map(
			(col: ColumnInterface<T>): ColumnInterface<T> => ({
				...col,
				visible: col.column === column ? !col.visible : col.visible,
			}),
		)
		this.columnsChange.emit(updatedColumns)
	}

	protected onDrop(event: CdkDragDrop<T>): void {
		const columns: ColumnInterface<T>[] = [...this.columns()]

		moveItemInArray(columns, event.previousIndex, event.currentIndex)
		this.columnsChange.emit(columns)
	}

	protected getTranslationByKey(column: T): string {
		const translationPrefix: string = this.translationPrefix()

		return translationPrefix ? `${translationPrefix}${column}` : this.string(column)
	}
}
